/**
 * Projection Web Mercator sphérique, EPSG:3857.
 *
 * Réimplémentée ici, en une dizaine de lignes, plutôt qu'emprutée à Leaflet.
 * La raison est architecturale : `src/core` ne doit dépendre d'aucune
 * bibliothèque d'affichage, sinon la logique de détection des feux ne serait
 * plus testable en Node ni réutilisable ailleurs.
 *
 * Les valeurs produites sont identiques à celles de `L.CRS.EPSG3857`, la
 * formule ci-dessous n'étant qu'une écriture équivalente de la sienne.
 */
import type { LatLon } from './types';

const RADIUS = 6378137;
const DEG = Math.PI / 180;

/** Au-delà, la projection diverge. Sans objet pour la France, mis par sûreté. */
const MAX_LATITUDE = 85.0511287798;

export interface Point {
  x: number;
  y: number;
}

/** Degrés vers mètres projetés. */
export function project(lat: number, lon: number): Point {
  const clamped = Math.max(-MAX_LATITUDE, Math.min(MAX_LATITUDE, lat));
  return {
    x: RADIUS * lon * DEG,
    y: RADIUS * Math.log(Math.tan(Math.PI / 4 + (clamped * DEG) / 2)),
  };
}

/** Mètres projetés vers degrés. */
export function unproject(x: number, y: number): LatLon {
  return {
    lat: (2 * Math.atan(Math.exp(y / RADIUS)) - Math.PI / 2) / DEG,
    lon: x / RADIUS / DEG,
  };
}
